import { Flex } from '@byecode/ui'
import type { AnyObject, DataSourceAbstract, DevicePreviewEnum } from '@lighthouse/core'
import React from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { ErrorMessage } from '../../../ErrorMessage'
import { FieldInput } from '../../../FieldInput'
import type { CascadeParam, RelativeFieldParam } from '../../../FieldInput/types'
import { getFieldInputConfig } from '../../helps'
import type { AccountPerfectForm } from '../../types'

const SCxItem = styled.div`
    width: 100%;
`
interface PerfectFieldsProps extends RelativeFieldParam, CascadeParam {
    dataSource?: DataSourceAbstract
    errors: AnyObject
}

export const PerfectFields: React.FunctionComponent<PerfectFieldsProps> = ({
    dataSource,
    errors,
    dataSourceList,
    onFetchCascadeOptions,
    onFetchDataSource,
    onLoadMoreData
}) => {
    const { control } = useFormContext<AccountPerfectForm>()
    const { t } = useTranslation()

    const { fields } = useFieldArray({
        control,
        name: 'fields'
    })
    return (
        <Flex direction="column" gap={20}>
            {fields.map((config, index) => {
                const { fieldId, title, placeHolder, required } = config
                const field = dataSource?.schema?.[fieldId]
                return (
                    <SCxItem key={fieldId}>
                        <Controller
                            name={`fields.${index}.value`}
                            control={control}
                            rules={required ? { required: t('notEmpty') } : undefined}
                            render={({ field: { value, onChange } }) => (
                                <ErrorMessage name={`fields.${index}.value`} errors={errors}>
                                    <FieldInput
                                        id="perfect"
                                        dataSource={dataSource}
                                        mode="datasource"
                                        config={getFieldInputConfig({ field, config })}
                                        value={value}
                                        style={{ padding: 0 }}
                                        // relativeDataSource={relativeDataSource}
                                        dataSourceList={dataSourceList}
                                        onChange={fieldInputValue => {
                                            onChange(fieldInputValue.value)
                                        }}
                                        onFetchCascadeOptions={onFetchCascadeOptions}
                                        onFetchDataSource={onFetchDataSource}
                                        onLoadMoreData={onLoadMoreData}
                                    />
                                </ErrorMessage>
                            )}
                        />
                    </SCxItem>
                )
            })}
        </Flex>
    )
}
